import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';
import './feedback.css';

export default function Toast({ open, onClose, message, autoHideDuration = 4000 }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  return (
    <Snackbar
      className="remote-toast"
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      transitionDuration={reducedMotion ? 0 : 150}
      ContentProps={{ className: 'remote-toast-content', role: 'alert' }}
      message={message}
      action={
        <button className="remote-toast-dismiss" type="button" aria-label="Dismiss notification" onClick={onClose}>
          <CloseIcon aria-hidden="true" />
        </button>
      }
    />
  );
}
